import { useEffect } from 'react';

import { setHoverErrors } from 'src/utils/formHelper';
import { UseAnyRequestErrorsConfigType } from 'src/models/useAnyRequest';
import { useAnyRequestErrorsState } from 'src/utils/hooks/useAnyRequestErrorsState';
import { FormPropsType } from 'src/components/UI/types';
import { SafeAnyType } from 'src/utils/safeAny';
import { StateFormSetError } from 'src/utils/stateForm';

export const useSetHoverErrors = <R = SafeAnyType>(
  uniqueId: string,
  setError: FormPropsType['setError'] | StateFormSetError,
  config: UseAnyRequestErrorsConfigType<R> = {}
): ReturnType<typeof useAnyRequestErrorsState> => {
  const { response, formErrors, ...requestErrorsStateProps } = useAnyRequestErrorsState<R>(uniqueId, {
    showErrors: false,
    ...config,
  });

  useEffect(() => {
    if (formErrors.length) {
      setHoverErrors(setError, formErrors);
    }
  }, [formErrors, setError]);

  return { response, formErrors, ...requestErrorsStateProps };
};
